import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerAccountsAdBlocksFlatTeamSettingGroupId =
  "customer_accounts_ad_blocks.ad_blocks";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Storefront customer-account settings including native accounts, ad blocks, and integrations.",
};

export const CustomerAccountsAdBlocksFlatTeamSettingGroups = [
  {
    id: "customer_accounts_ad_blocks.ad_blocks",
    title: "Ad blocks",
    description: "Ad blocks settings on the Customer accounts ad blocks page.",
    productArea: "general",
    access: directMerchantAccess(
      SettingsPermissions.SET_CUSTOMER_ACCOUNTS_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "customer-accounts-ad-blocks" },
    synonyms: ["ad blocks", "customer accounts ad blocks"],
  },
] as const satisfies readonly SettingGroupDefinition<CustomerAccountsAdBlocksFlatTeamSettingGroupId>[];

type _assertAllCustomerAccountsAdBlocksFlatTeamSettingGroupsProvided =
  CustomerAccountsAdBlocksFlatTeamSettingGroupId extends (typeof CustomerAccountsAdBlocksFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allCustomerAccountsAdBlocksFlatTeamSettingGroupsProvided: _assertAllCustomerAccountsAdBlocksFlatTeamSettingGroupsProvided = true;
void _allCustomerAccountsAdBlocksFlatTeamSettingGroupsProvided;

export const CustomerAccountsAdBlocksFlatTeamSettingGroupById: Record<
  CustomerAccountsAdBlocksFlatTeamSettingGroupId,
  SettingGroupDefinition<CustomerAccountsAdBlocksFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      CustomerAccountsAdBlocksFlatTeamSettingGroupId,
      SettingGroupDefinition<CustomerAccountsAdBlocksFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of CustomerAccountsAdBlocksFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  return map as Record<
    CustomerAccountsAdBlocksFlatTeamSettingGroupId,
    SettingGroupDefinition<CustomerAccountsAdBlocksFlatTeamSettingGroupId>
  >;
})();
